import React, {useEffect, useRef, useState} from "react";
import {useAuthContext} from "../../services/auth.service";
import {useDataContext} from "../../services/data.service";
import {useNavigate} from "react-router-dom";

const UserMenu = ({cancel, buttonEl}) => {
    const { logout: rawLogout } = useAuthContext();
    const navigate = useNavigate();

    const logout = () => {
        cancel();
        rawLogout();
        navigate("/");
    }

    const menuEl = useRef(null);

    useEffect(() => {
        if (menuEl && menuEl.current && buttonEl && buttonEl.current) {
            const handleClickOutside = event => {
                if (!menuEl.current.contains(event.target) && !buttonEl.current.contains(event.target)) {
                    cancel();
                }
            };

            document.addEventListener("mousedown", handleClickOutside);

            return () => document.removeEventListener("mousedown", handleClickOutside);
        }
    }, [menuEl, buttonEl])

    return (
        <div ref={menuEl} className="absolute top-12 w-64 shadow-lg right-0 bg-white text-slate-900" style={{zIndex: 999}}>
            <h3 className="text-3xl px-4 py-3">User Options</h3>
            <div className="flex flex-col mx-auto w-44 gap-2 p-4">
                <button className="py-1 px-2 bg-gray-600 hover:bg-blue-600 text-gray-100 rounded uppercase tracking-wide" onClick={() => logout()}>Log out</button>
                <button  className="py-2 px-3 hover:bg-gray-300 hover:text-gray-600 text-gray-500 rounded uppercase text-xs font-bold tracking-wide" onClick={() => cancel()}>Close menu</button>
            </div>
        </div>
    )
}

const User = () => {
    const { userTypes } = useDataContext();
    const { user } = useAuthContext();
    const [menuOpen, rawSetMenuOpen] = useState(false);

    const {setIsMenuOpen} = useDataContext();
    const buttonEl = useRef(null);

    const setMenuOpen = val => {
        if (typeof val !== "boolean") return;

        setIsMenuOpen(val);
        rawSetMenuOpen(val);
    }

    return (
        <>
            { menuOpen ? <UserMenu buttonEl={buttonEl} cancel={() => setMenuOpen(false)} /> : null }
        <button className="flex items-center px-4 text-gray-300 hover:text-white hover:bg-slate-800" onClick={() => setMenuOpen(!menuOpen)} ref={buttonEl}>
            <div className="flex flex-col text-right justify-center h-12 mr-3">
                <span className="text-current text-base -mt-0.5"> { user.name }</span>
                { !!userTypes ? <span className="text-slate-400 text-xs uppercase font-semibold tracking-wider -mt-1">{ userTypes.find(type => type.id === user.user_type).name}</span> : null }
            </div>
            <div className="bg-slate-500 rounded-full w-8 h-8 overflow-hidden border border-gray-400 group-hover:border-0 group-hover:bg-gray-400  group-hover:ring ring-gray-500 group-hover:text-slate-800 text-slate-900">
                <svg width="100%" height="100%" viewBox="0 0 2859 2859" version="1.1" >
                    <g transform="matrix(4.16667,0,0,4.16667,0,0)">
                        <path d="M320.813,77.009C307.041,77.451 295.803,81.431 287.427,89.166C284.016,92.26 276.631,95.905 271.127,97.011C264.075,98.559 255.261,105.519 242.041,119.995C208.328,156.794 200.837,183.868 209.434,237.461C212.186,254.591 215.048,271.939 215.601,275.917C216.261,280.005 214.831,283.872 212.407,284.868C202.16,288.845 214.057,356.475 226.839,367.415C230.254,370.287 235.98,382.223 239.617,393.937C239.728,394.38 239.944,394.928 240.06,395.371C240.387,395.039 240.498,394.928 240.829,394.487C242.701,410.402 268.592,470.292 323.455,492.394C295.692,485.102 275.861,470.182 257.792,455.265C257.907,457.808 257.907,460.458 257.907,463.442L257.907,488.308L245.785,494.496C234.661,500.24 233.777,501.788 232.344,516.593C231.467,525.437 228.051,536.153 224.857,540.353C221.547,544.665 207.116,553.615 192.576,560.245C170.981,570.191 159.412,573.393 128.785,577.372C81.196,583.559 62.463,588.976 45.828,601.687C30.405,613.507 20.493,629.422 13.33,653.842C10.574,663.235 7.601,672.739 6.831,674.838C4.296,678.815 2.203,682.353 0,686L683.266,686C681.503,683.347 679.633,680.583 677.647,677.709C675.774,675.061 662.114,631.63 658.038,624.006C646.471,601.687 621.023,587.207 587.419,583.781C538.392,578.699 516.913,573.172 488.158,558.698C457.861,543.449 450.701,535.051 450.588,514.387C450.48,503.336 448.167,499.798 436.599,494.384C427.785,490.185 427.234,488.856 425.799,466.65C424.481,447.089 425.363,440.571 431.092,426.976C434.946,417.915 441.005,401.562 444.53,390.511C448.056,379.459 452.906,369.735 455.219,368.85C461.606,366.421 472.512,333.932 474.605,311.28C476.15,295.034 475.598,290.504 471.632,287.632C467.557,284.536 467.116,280.337 469.43,260.667C473.947,221.328 472.735,183.094 466.345,167.402C460.949,153.921 460.949,153.258 466.456,145.633C469.649,141.213 473.067,131.93 474.168,124.968L476.15,112.151L457.861,111.929C446.515,111.819 431.203,108.835 417.761,103.973C405.859,99.664 384.379,91.817 369.835,86.512C350.998,79.662 334.583,76.567 320.813,77.009Z" className="fill-current"/>
                    </g>
                </svg>
            </div>
        </button>
        </>
    )
};

export default User;